import { auth } from '../services/supabase';
import { webPush } from '../services/webPush';
import { createAuthStore } from './createAuthStore';

/** The site's auth store, on the site's session and this browser's web push, initialized on module load. */
export const useAuthStore = createAuthStore(auth, webPush);

useAuthStore.getState().initialize();
